import {
  SHOW_TURNTABLE,
  SET_TURNTABLE_SIZE,
  SET_RESULT_SELECTED,
  SET_CHOICES,
  SET_SHOW_MODE,
  SET_CONTINENTS_ACTIVE,
  SET_HISTORY,
  SET_TITLE_OBJ,
  SET_MODE,
  SET_MYSTERY_WHEEL_ON,
  SET_MYSTERY_RESULT_ON,
  UPDATE_MYSTERY_SETTINGS,
  SET_SCORES,
  SET_AUTO_ADD_COUNT,
  SYNC_INPUTS_SETTINGS,
  SET_ANSWER_CHOICE_COUNT,
} from './constants'
import { setStartRotate } from '../turntable/actions'
import { setDataStatus } from '../common/actions'

export const showTurntable = turntable => ({
  type: SHOW_TURNTABLE,
  payload: {
    turntable,
  },
})

export const setTurntableSize = size => ({
  type: SET_TURNTABLE_SIZE,
  payload: {
    size,
  },
})

export const setResultSelected = (
  result,
  resultIndex = -1,
  resultPieColor = null,
) => ({
  type: SET_RESULT_SELECTED,
  payload: {
    result,
    resultIndex,
    resultPieColor,
  },
})

export const setHistory = history => ({
  type: SET_HISTORY,
  payload: {
    history,
  },
})

export const setChoices =
  (choices, resetAngle = true) =>
  async (dispatch, getState) => {
    if (resetAngle) {
      const state = getState()
      const startAngle = state.settings.spinBehavior.randomStart
        ? 2 * Math.PI * Math.random()
        : 0
      dispatch(setStartRotate(startAngle))
    }
    dispatch(setChoicesAction(choices))
  }

export const setChoicesAction = (choices, nullTurntable = true) => ({
  type: SET_CHOICES,
  payload: {
    choices,
    nullTurntable,
  },
})

export const setMode = mode => ({
  type: SET_MODE,
  payload: {
    mode,
  },
})

export const setShowMode = showMode => dispatch => {
  dispatch({
    type: SET_SHOW_MODE,
    payload: {
      showMode,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setContinentsActive = continentsActive => dispatch => {
  dispatch({
    type: SET_CONTINENTS_ACTIVE,
    payload: {
      continentsActive,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setTitleActive = active => dispatch => {
  dispatch(setTitleObj({ active }))
}

export const setTitleText = text => dispatch => {
  dispatch(setTitleObj({ text }))
}

export const setTitleObj = obj => dispatch => {
  dispatch({
    type: SET_TITLE_OBJ,
    payload: {
      obj,
    },
  })
  dispatch(setDataStatus('Modified', 'Title & Desc.'))
}

export const setMysteryWheelOn = status => dispatch => {
  dispatch({
    type: SET_MYSTERY_WHEEL_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Mystery'))
}

export const setMysteryResultOn = status => dispatch => {
  dispatch({
    type: SET_MYSTERY_RESULT_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Mystery'))
}

export const updateMysterySettings =
  (mysteryWheelOn, mysteryResultOn) => async (dispatch, getState) => {
    try {
      const state = getState()
      const pastMysteryWheelOn = state.cfq.mysteryWheelOn
      dispatch({
        type: UPDATE_MYSTERY_SETTINGS,
        payload: {
          mysteryWheelOn,
          mysteryResultOn,
        },
      })
      // redraw wheel
      if (pastMysteryWheelOn !== mysteryWheelOn) {
        dispatch(showTurntable(null))
      }
    } catch (error) {
      console.log(error)
    }
  }

export const setScores = scores => ({
  type: SET_SCORES,
  payload: {
    scores,
  },
})

export const setAutoAddCount = status => ({
  type: SET_AUTO_ADD_COUNT,
  payload: {
    status,
  },
})

export const syncInputSettings = () => async (dispatch, getState) => {
  try {
    const fromTool = 'rcg'
    const state = getState()
    const choices = state[fromTool].choices
    const continentsActive = state[fromTool].continentsActive
    const showMode = state[fromTool].showMode
    dispatch({
      type: SYNC_INPUTS_SETTINGS,
      payload: {
        choices,
        continentsActive,
        showMode: showMode === 'Flag & Name' ? 'Mixed' : showMode,
      },
    })
    return Promise.resolve()
  } catch (error) {
    console.log(error)
    return Promise.reject(error)
  }
}

export const setAnswerChoiceCount = count => dispatch => {
  dispatch({
    type: SET_ANSWER_CHOICE_COUNT,
    payload: {
      count,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}
